
import stringMixin from './stringMixin';
import { crmQueryReceivablesPlansByContractIdAPI } from '@/api/crm/contract';

export default {
  name: 'XhReceivablesPlan', // 回款 下的 回款计划
  components: {},
  mixins: [stringMixin],
  props: {
    relation: {
      // 相关ID
      type: Object,
      default: function _default() {
        return {};
      }
    },
    receivablesId: [String, Number]
  },
  data: function data() {
    return {
      option: []
    };
  },

  computed: {},
  watch: {
    relation: function relation(val) {
      if (val.moduleType) {
        this.getPlanList();
      } else {
        this.option = [];
      }
    }
  },
  mounted: function mounted() {
    if (this.relation.moduleType) {
      this.getPlanList();
    }
  },

  methods: {
    getPlanList: function getPlanList() {
      var _this = this;

      this.loading = true;
      var params = { contract_id: this.relation.contract_id, pageType: 'all', status: 0 };
      if (this.receivablesId) {
        params.receivables_id = this.receivablesId;
      }
      crmQueryReceivablesPlansByContractIdAPI(params).then(function (res) {
        _this.loading = false;
        _this.option = res.data.list;
      }).catch(function () {
        _this.loading = false;
      });
    },


    // 输入的值
    valueChange: function valueChange(val) {
      this.$emit('value-change', {
        index: this.index,
        value: val,
        data: this.option.find(function (item) {
          return item.plan_id == val;
        })
      });
    }
  }
};